import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div style={{paddingTop: '3rem' }}>
      <Helmet>
        <title>404 - Page Not Found</title>
        <meta name="description" content="Sorry, the page you are looking for could not be found. Return to our homepage or contact us for assistance." />
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="container py-5 h-100" >
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-xl-8">
            <div className="card rounded-3 text-black">
              <div className="row g-0">
                <div className="col-lg-6">
                  <div className="card-body p-md-5 mx-md-4 text-center">
                    <img
                      src={"../images/logo-new.png"}
                      style={{ width: '185px' }}
                      alt="Logo"
                      className="mb-4"
                    />
                    <h1 className="admin-heading mb-3">404 - Page Not Found</h1>
                    <p className="admin-text mb-4">
                      Sorry, the page you're looking for doesn't exist or has been moved.
                    </p>
                    <Link
                      to="/"
                      className="btn-custom mb-3"
                    >
                      Back to Homepage
                    </Link>
                    <p className="admin-text small">
                      Try searching for what you need or{' '}
                      <Link to="/contact" className="admin-text text-muted">
                        contact us
                      </Link>{' '}
                      for assistance.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 d-flex align-items-center admin-gradient-bg">
                  <div className="text-white px-3 py-4 p-md-5 mx-md-4">
                    <h4 className="mb-4 text-white">Explore Our Site</h4>
                    <p className="small mb-0">
                      It looks like you took a wrong turn. Why not explore our services, courses, or contact us to find what you're looking for?
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;